import { PARTNER_API } from '../config';
import { dataUtils } from './data-service-util.js';
import { commonAPIConversion } from './api-conversion-common.js';
import { partnerAPIConversion } from './api-conversion-partner.js';
import axios from 'axios';

// ************************************************
// ****  Get Partner Types
// ************************************************
const loadPartnerTypes = async function(searchInfo) {
  const url = dataUtils.getSearchUrl(`${PARTNER_API}/option/partner_type`, searchInfo);
  console.log(`[loadPartnerTypes] - get call to: [${url}}]`);
  try {
    const response = await axios.get(url);
    const pageInfo = dataUtils.parseVinaEntityPageInfo(response, 'partner_type', 'partnerTypes');
    pageInfo.partnerTypes = commonAPIConversion.convertOptionListFromAPI(pageInfo.partnerTypes);
    console.log('successfully retrieved all partner types - response:');
    console.log(pageInfo);
    return pageInfo;
  } catch (error) {
    console.error('[loadPartnerTypes] - get call failed - error:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      partnerTypes: []
    };
  }
};

// **************************************
// ****  Find Partners
// **************************************
const findPartners = async function(searchInfo, partnerTypeCode) {
  const url = dataUtils.getSearchUrl(`${PARTNER_API}/partner`, searchInfo, `partner_type_code=${partnerTypeCode}`);
  console.log(`[findPartners] - get call to: [${url}}]`);
  try {
    const response = await axios.get(url);
    const pageInfo = dataUtils.parseVinaEntityPageInfo(response, 'partner', 'partners');
    pageInfo.partners = partnerAPIConversion.convertPartnerListFromAPI(pageInfo.partners);
    return pageInfo;
  } catch (error) {
    console.error('[findPartners] - get call failed - error:');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      partners: []
    };
  }
};

// **************************************
// ****  Create Partner
// **************************************
const createPartner = async function(partner) {
  console.log('[createPartner] - post call create:');
  console.log(partner);
  const newPartner = partnerAPIConversion.convertPartnerToAPI(partner);
  try {
    const response = await axios.post(`${PARTNER_API}/partner`, newPartner);
    if (response.status != 201) {
      console.error(`failed to create new partner - error http status: [${response.status}], message: [${response.message}]`);
      return {
        successful: false,
        httpStatus: response.status,
        errorMessage: response.message
      }
    }
    return {
      successful: true,
      httpStatus: response.status,
      partner: partnerAPIConversion.convertPartnerFromAPI(response.data.entity)
    };
  } catch (error) {
    console.error('[createPartner] failed to create new partner - error');
    console.error(error);
    return {
      successful: false,
      httpStatus: error.response.status,
      errors: error.response.data.errors
    };
  }
};

// ****************************************************************
// ****  Expose API Method Calls to Components
// ****************************************************************
export const partnerDataSvc = {
  loadPartnerTypes,
  findPartners,
  createPartner
};
